// extracted by mini-css-extract-plugin
module.exports = {"modal-container":"ShortVideosPlayer_modal-container__1OzEQ","title":"ShortVideosPlayer_title__Ap3BU"};